import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { getPaymentStatus } from "store/actions/auth.action";
import { SHOW_PAYMENT_FAILED } from "store/actions/types";
import { handlePageLoader } from "utils/handler";

type PaymentProgressProps = {

};

const PaymentProgress: React.FC<PaymentProgressProps> = ({ }) => {

    const history = useHistory();
    const dispatch = useDispatch();

    const urlParams = new URLSearchParams(history.location.search);
    const sessionId = urlParams.get('session_id');

    const getStatus = async () => {
        const response = await getPaymentStatus(sessionId || "");
        console.log("Payment status: ", response?.data)
        handlePageLoader(false)
        if (response?.data?.success && response?.data?.status === 'complete') {
            history.push("/calendly");
        } else {
            dispatch({ type: SHOW_PAYMENT_FAILED, payload: true });
            history.push("/")
        }
    }

    useEffect(() => {
        handlePageLoader(true)
        getStatus()
    }, [])

    return (<div></div>)
}

export default PaymentProgress;